// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"61":"94b1bb30","241":"fc9f27ab","283":"fbada3aa","720":"b0983886","824":"b67d3770","884":"e3a498e7"}[chunkId] + ".css";
};